import cacheService from '../../../services/cacheService';
import submitCommand from '../../../services/submitCommand';

export const removeCourse = (courseId: string, orgId: string, initiatingUserId: string) => {
  cacheService.removeAllInPath(`/v1/tasklists?orgId=${orgId}`);
  return submitCommand(
    courseId,
    {
      id: courseId,
      initiatingUserId,
      taskListId: courseId,
      organizationId: orgId,
    },
    'DeleteTaskList',
    'TaskListDeleted',
    'DeleteTaskListFailed'
  );
};
